import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { MutateOptions } from '@tanstack/react-query';

import {
  QuizToastActions,
  apiToaster,
} from '~teacher/components/quizzes/toastActions/';
import { decreaseQuizCount } from '~teacher/hook/useQuizLimit';
import { quizzesQueryKey } from '~teacher/hook/useQuizzes';

import {
  DeleteQuizFolderParam,
  DeleteQuizFolderResponse,
  deleteQuizFolder,
} from '../../api/quiz';

export function useDeleteQuizFolder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteQuizFolder,
    onSuccess: (
      data: DeleteQuizFolderResponse,
      variables: DeleteQuizFolderParam
    ) => {
      // this assumes that all the quizzes that were deleted were in the payload
      const deletedQuizzes = variables.quizIds?.length ?? 0;
      if (deletedQuizzes > 0) {
        decreaseQuizCount(queryClient, deletedQuizzes);
      }
      return queryClient.invalidateQueries(quizzesQueryKey.quiz);
    },
    onError: (error) => {
      apiToaster([], QuizToastActions.DELETE, error);
    },
  });
}

export type DeleteQuizError = unknown;

export type DeleteQuizFolderMutation = UseMutateFunction<
  DeleteQuizFolderResponse,
  DeleteQuizError,
  DeleteQuizFolderParam
>;

export type DeleteQuizFolderOptions = MutateOptions<
  DeleteQuizFolderResponse,
  DeleteQuizError,
  DeleteQuizFolderParam
>;
